import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { CssBaseline } from "@mui/material";
import { SnackbarProvider } from "notistack";
import Routes from './routes';

const root = ReactDOM.createRoot(document.getElementById('root'));

// Modern MUI Theme
const theme = createTheme({
  palette: {
    primary: {
      main: '#0c5470',
      light: '#4a90a4',
      dark: '#003c52',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#428bca',
      light: '#6ba4d6',
      dark: '#2e5f8a',
    },
    background: {
      default: '#f8f9fb',
      paper: '#ffffff',
    },
  },
  typography: {
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif",
    h1: {
      fontSize: '3rem',
      fontWeight: 700,
      lineHeight: 1.2,
    },
    h2: {
      fontSize: '2.25rem',
      fontWeight: 600,
      lineHeight: 1.3,
    },
    h3: {
      fontSize: '1.875rem',
      fontWeight: 600,
      lineHeight: 1.4,
    },
    body1: {
      fontSize: '1rem',
      lineHeight: 1.6,
    },
  },
  shape: {
    borderRadius: 12,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          minHeight: '100vh',
          backgroundColor: '#f8f9fb',
        },
      },
    },
  },
});

root.render(
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <SnackbarProvider maxSnack={3}>
      <Routes />
    </SnackbarProvider>
  </ThemeProvider>
);
